import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText,
  HeaderText,
  Modal,
} from '../../../ui';
import analytics from '../../../../modules/analytics';
import Separator from '../../../ui/Separator';
import FormButtonRow from './FormButtonRow';
import FormButtonCancel from './FormButtonCancel';
import FormButtonSubmit from './FormButtonSubmit';

export default function DeleteConfirmationModal({ onDelete, close }) {
  const handleDelete = () => {
    analytics.track('pro_deleted_product');
    if (typeof onDelete === 'function') {
      onDelete();
    }
    if (typeof close === 'function') {
      close();
    }
  };

  return (
    <Modal
      renderTitle={() => (
        <HeaderText
          level="5"
          style={{
            flex: 1,
            paddingLeft: 36,
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: '16px',
          }}
        >
          Delete Product
        </HeaderText>
      )}
      padding={0}
      appearance="dialog"
      onCloseRequest={close}
    >
      <Separator appearance="extrathin" color={colors.lightGrey} />
      <Box padding={16}>
        <BodyText
          textAlign="center"
          style={{
            fontSize: '15px',
            fontWeight: 300,
            letterSpacing: 0,
            lineHeight: '18px',
          }}
        >
          Are you sure you want to delete this product?
        </BodyText>
      </Box>
      <FormButtonRow>
        <FormButtonCancel onPress={close}>Cancel</FormButtonCancel>
        <FormButtonSubmit onPress={handleDelete}>Delete</FormButtonSubmit>
      </FormButtonRow>
    </Modal>
  );
}
DeleteConfirmationModal.propTypes = {
  onDelete: PropTypes.func,
  close: PropTypes.func,
};
DeleteConfirmationModal.defaultProps = {
  onDelete: null,
  close: null,
};
